import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import store from 'redux/store';
import {
  GET_VEHICLE,
  GET_ADDVEHICLE,
  GET_DELETEVEHICLE,
  GET_UPDATEVEHICLE,
  GET_MATRIXVEHICLE,
  GET_MOREVEHICLE,
} from 'resources/actionTypes';
import {
  addVehicleApi,
  deleteVehicleApi,
  matrixVehicleApi,
  moreVehicleApi,
  updateVehicleApi,
  vehicleApi,
} from 'services/VehicleService';
import { getVehicle } from 'redux/actions/UserVehicle';
import { getOnBoardCompliance } from 'redux/actions/UserCompliance';
import { getDriver } from 'redux/actions/UserDriver';
import { onLoaderTrigger } from "redux/actions/commonAction";

function* fetchVehicle(action) {
  try {
    const payload = action.payload || {};
    const userVehicle = yield call(vehicleApi, payload);
    yield put({
      type: GET_VEHICLE.GET_VEHICLE_SUCCESS,
      userVehicle: userVehicle,
    });
  } catch (e) {
    yield put({
      type: GET_VEHICLE.GET_VEHICLE_FAILED,
      message: e.message,
    });
  }
}

export function* vehicleSaga() {
  yield takeEvery(GET_VEHICLE.GET_VEHICLE_REQUESTED, fetchVehicle);
}

function* fetchAddVehicle(action) {
  const payload = action.payload || {};
  const userAddVehicle = yield call(addVehicleApi, payload.userAddVehicle);
  if (userAddVehicle.success) {
    yield put({
      type: GET_ADDVEHICLE.GET_ADDVEHICLE_SUCCESS,
      userAddVehicle: userAddVehicle,
    });
    localStorage.setItem('vehicleId', userAddVehicle?.data[0]?.vehicleId);
    toast.success(userAddVehicle.message);
    store.dispatch(
      getVehicle({
        id: payload?.userAddVehicle?.get('id'),
        status: '',
        type: payload?.userAddVehicle?.get('type'),
        page: '',
        pageSize: '',
      })
    );
    store.dispatch(
      getOnBoardCompliance({
        vehicleId: userAddVehicle?.data[0]?.vehicleId,
        type: 'vehicleRegistration',
      })
    );
    store.dispatch(
      getDriver({ driverId: payload?.userAddVehicle?.get('driverId') })
    );
  } else {
    yield put({
      type: GET_ADDVEHICLE.GET_ADDVEHICLE_FAILED,
      message: userAddVehicle.message,
    });
      toast.error(userAddVehicle.message || 'Add Vehicle failed');
   
  }
}

export function* addVehicleSaga() {
  yield takeEvery(GET_ADDVEHICLE.GET_ADDVEHICLE_REQUESTED, fetchAddVehicle);
}

function* fetchUpdateVehicle(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const userUpdateVehicle = yield call(
    updateVehicleApi,
    payload.userUpdateVehicle
  );
  if (userUpdateVehicle.success) {
    yield put({
      type: GET_UPDATEVEHICLE.GET_UPDATEVEHICLE_SUCCESS,
      userUpdateVehicle: userUpdateVehicle,
    });
    toast.success(userUpdateVehicle.message);
    store.dispatch(onLoaderTrigger(false));
    if (payload?.userUpdateVehicle?.get('parentId')) {
      store.dispatch(
        getVehicle({
          id: payload?.userUpdateVehicle?.get('parentId'),
          type: payload?.userUpdateVehicle?.get('type'),
          status: '',
          page: payload?.userUpdateVehicle?.get('page'),
          search: payload?.userUpdateVehicle?.get('search'),
          pageSize: payload?.userUpdateVehicle?.get('pageSize'),
          date: '',
        })
      );
    } else {
      store.dispatch(
        getVehicle({ vehicleId: payload.userUpdateVehicle?.get('id') })
      );
    }
  } else {
    yield put({
      type: GET_UPDATEVEHICLE.GET_UPDATEVEHICLE_FAILED,
      message: userUpdateVehicle.message,
    });
    store.dispatch(onLoaderTrigger(false));
      toast.error(userUpdateVehicle?.message || 'Update Vehicle failed');
    
  }
}

export function* updateVehicleSaga() {
  yield takeEvery(
    GET_UPDATEVEHICLE.GET_UPDATEVEHICLE_REQUESTED,
    fetchUpdateVehicle
  );
}

function* fetchDeleteVehicle(action) {
  const payload = action.payload || {};
  const userDeleteVehicle = yield call(
    deleteVehicleApi,
    payload.userDeleteVehicle
  );
  if (userDeleteVehicle.success) {
    yield put({
      type: GET_DELETEVEHICLE.GET_DELETEVEHICLE_SUCCESS,
      userDeleteVehicle: userDeleteVehicle,
    });
    toast.success(userDeleteVehicle.message);
    store.dispatch(
      getVehicle({ vehicleId: payload.userDeleteVehicle.vehicleId })
    );
  } else {
    yield put({
      type: GET_DELETEVEHICLE.GET_DELETEVEHICLE_FAILED,
      message: userDeleteVehicle.message,
    });
      toast.error(userDeleteVehicle?.message || 'Delete Vehicle failed');
  }
}

export function* deleteVehicleSaga() {
  yield takeEvery(
    GET_DELETEVEHICLE.GET_DELETEVEHICLE_REQUESTED,
    fetchDeleteVehicle
  );
}

function* fetchMatrixVehicle(action) {
  try {
    const payload = action.payload || {};
    const userMatrixVehicle = yield call(matrixVehicleApi, payload);
    yield put({
      type: GET_MATRIXVEHICLE.GET_MATRIXVEHICLE_SUCCESS,
      userMatrixVehicle: userMatrixVehicle,
    });
  } catch (e) {
    yield put({
      type: GET_MATRIXVEHICLE.GET_MATRIXVEHICLE_FAILED,
      message: e.message,
    });
  }
}

export function* matrixVehicleSaga() {
  yield takeEvery(
    GET_MATRIXVEHICLE.GET_MATRIXVEHICLE_REQUESTED,
    fetchMatrixVehicle
  );
}

function* fetchMoreVehicle(action) {
  try {
    const payload = action.payload || {};
    const userMoreVehicle = yield call(moreVehicleApi, payload);
    yield put({
      type: GET_MOREVEHICLE.GET_MOREVEHICLE_SUCCESS,
      userMoreVehicle: userMoreVehicle,
    });
  } catch (e) {
    yield put({
      type: GET_MOREVEHICLE.GET_MOREVEHICLE_FAILED,
      message: e.message,
    });
  }
}

export function* moreVehicleSaga() {
  yield takeEvery(GET_MOREVEHICLE.GET_MOREVEHICLE_REQUESTED, fetchMoreVehicle);
}
